import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: 'views.Departments.heading.title',
    defaultMessage: 'Jesteśmy obecni w {countryCount} krajach:'
  }
});



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Departments/Departments.intl.js